/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */

import React from "react";

export const Loading = () => {
    return(
        <div className="container mt-5 d-flex flex-column justify-content-center align-items-center w-100" style={{ height: '550' }}>
            <div className="spinner-border" role="status" style={{ color: "#d91604", width: '3rem', height: '3rem' }}>
                <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-center" style={{ color: "#7c7d7c", fontWeight: "600", fontSize: "14px" }}>{'Processing page content. This may take a few moments...'}</p>
        </div>
    );
}